// MEO Phase 1 Sprint 2-F (2026-05-13): landmark_neighborhoods CRUD store.
// 既存 LandmarkStore のパターンを踏襲。
// 1 main landmark あたり 10 件上限 (= backend で enforce、UI でも表示)。

import { LandmarkNeighborhoodsApi } from '@/apis';
import { ResponseData } from '@/types/http';
import { flow, makeObservable, observable } from 'mobx';
import RootStore from '.';
import BaseStore from './BaseStore';

export default class LandmarkNeighborhoodsStore extends BaseStore {
    neighborhoods: any[] = [];
    total: number = 0;
    api: LandmarkNeighborhoodsApi;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            neighborhoods: observable,
            total: observable,
            list: flow.bound,
            create: flow.bound,
            update: flow.bound,
            remove: flow.bound
        });
        this.api = new LandmarkNeighborhoodsApi();
    }

    *list(landmarkId: string | number) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.list, landmarkId);
            if (res?.ok) {
                this.neighborhoods = res.data?.items ?? [];
                this.total = res.data?.total ?? 0;
            }
            return res;
        } catch (_e) {
            return null;
        }
    }

    *create(payload: { landmarkId: string | number, data: any }) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.create, payload);
            return res;
        } catch (e: any) {
            return e?.data;
        }
    }

    *update(payload: { landmarkId: string | number, id: string | number, data: any }) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.update, payload);
            return res;
        } catch (e: any) {
            return e?.data;
        }
    }

    *remove(payload: { landmarkId: string | number, id: string | number }) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.remove, payload);
            return res;
        } catch (e: any) {
            return e?.data;
        }
    }
}
